module.exports = __webpack_public_path__ + "gigio_attanasio-670x1024.jpg?9d7bee1c7c285682de04b0b281f82bbc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/judge/gigio_attanasio-670x1024.jpg
// module id = 118
// module chunks = 0